import { HubbleFullSvg } from "~/assets/assets";

export default function RNRCodeHubbleBranding() {
  return (
    <div
      id="rnr-hubble-branding"
      class="flex flex-row items-center justify-center"
    >
      <span class={` text-buttonMedium text-baseDark `}>Powered by</span>
      <div class="w-[8px]" />
      <div class="h-[2px]" />
      <HubbleFullSvg class="h-[13px] fill-baseDark" />
    </div>
  );
}
